export const UI_REQUEST = 'UI_REQUEST'
export const UI_SUCCESS = 'UI_SUCCESS'
export const UI_ERROR = 'UI_ERROR'
export const UI_INIT_APPLICATION = 'UI_INIT_APPLICATION'
export const UI_FREE_APPLICATION = 'UI_FREE_APPLICATION'
export const UI_INIT_UI = 'UI_INIT_UI'
export const UI_FREE_DATA = 'UI_FREE_DATA'
export const UI_SET_MODULE = 'UI_SET_MODULE'
export const UI_SET_MODULES = 'UI_SET_MODULES'
export const UI_SET_ACTIONS = 'UI_SET_ACTIONS'
export const UI_ADD_ACTION = 'UI_ADD_ACTION'
export const UI_SET_ACTION_PARAMS = 'UI_SET_ACTION_PARAMS'
export const UI_DEL_ACTION = 'UI_DEL_ACTION'
export const UI_INVOKE_ACTION = 'UI_INVOKE_ACTION'
export const UI_INVOKE_REPORT = 'UI_INVOKE_REPORT'
export const UI_SNACKBAR = 'UI_SNACKBAR'
export const UI_ALLOW_LONGPOLL = 'UI_ALLOW_LONGPOLL'
